// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab[data-v-29d118a4]{font-size:12px;display:inline-flex;background:transparent;padding:8px 16px;color:#90a4ae;border:1px solid transparent}.tab.active[data-v-29d118a4],.tab[data-v-29d118a4]:hover{border-radius:24px;background:#fff;cursor:pointer;color:#f5c51e;border:1px solid #f5c51e}", ""]);
// Exports
module.exports = exports;
